import { BaseContainerModel } from '../base-container.model';
import * as fromDatatype from '../../datatype-library';

export class InventoryOpdgElementReportContainerModel extends BaseContainerModel {
  element_guid?: string;
  hdr_guid?: string;
  hdr_revision?: string;
  location_guid?: string;
  hdr_created_date?: fromDatatype.TimestampTzDatatypeInterface;
  hdr_modified_date?: fromDatatype.TimestampTzDatatypeInterface;
  hdr_status?: string;

  // Location fields
  outlet_name?: string;
  outlet_code?: string;
  description?: string;
  outlet_size_code?: string;
  outlet_type_code?: string;
  outlet_created_date?: fromDatatype.TimestampTzDatatypeInterface;
  outlet_modified_date?: fromDatatype.TimestampTzDatatypeInterface;

  // Brand fields
  brand_corner_boolean?: boolean;
  brand_guid?: string;
  brand?: string;
  brand_qty?: number;
  pdg_qty?: number;
  opdg_qty?: number;

  // Category L1 fields
  category_l1_guid?: string;
  category_l1_code?: string;
  category_l1_name?: string;

  // Category L2 fields
  category_l2_guid?: string;
  category_l2_code?: string;
  category_l2_name?: string;

  // Category L3 fields
  category_l3_guid?: string;
  category_l3_code?: string;
  category_l3_name?: string;

  opdg_qty_for_element?: number;
}
